
import { useState } from 'react';
import Header from '../../../components/layout/Header';
import Footer from '../../../components/layout/Footer';
import WhatsAppFloat from '../../../components/ui/WhatsAppFloat';

const CreacionCorporacionesPage = () => {
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState('beneficios');



  const faqs = [
    {
      question: '¿Cuál es la diferencia entre LLC y Corporación?',
      answer: 'Una LLC ofrece flexibilidad fiscal y simplicidad operativa, ideal para pequeños y medianos negocios. Una Corporación es mejor para empresas que buscan inversión externa o planean salir a bolsa, con estructura más formal pero mayores beneficios fiscales.'
    },
    {
      question: '¿Por qué Delaware es el mejor estado para incorporar?',
      answer: 'Delaware ofrece las leyes corporativas más favorables, tribunales especializados en derecho empresarial, privacidad mejorada, y es reconocido internacionalmente. El 65% de las empresas Fortune 500 están incorporadas en Delaware.'
    },
    {
      question: '¿Cuánto tiempo toma el proceso completo?',
      answer: 'El proceso típico toma entre 2-4 semanas dependiendo del tipo de entidad y los servicios adicionales. Ofrecemos servicio expedito en 7-10 días por un costo adicional.'
    },
    {
      question: '¿Necesito estar físicamente en Estados Unidos?',
      answer: 'No es necesario. Podemos formar su corporación completamente de forma remota. Sin embargo, recomendamos tener un agente registrado en el estado de incorporación.'
    },
    {
      question: '¿Qué incluye el compliance corporativo?',
      answer: 'Incluye presentación de reportes anuales, mantenimiento de registros corporativos, renovación de licencias, y asegurar que la entidad mantenga su estatus legal activo.'
    },
    {
      question: '¿Puedo cambiar de LLC a Corporación después?',
      answer: 'Sí, es posible convertir una LLC a Corporación, aunque el proceso puede ser complejo. Es mejor elegir la estructura correcta desde el inicio basado en sus objetivos a largo plazo.'
    }
  ];



  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Protección de Activos',
      description: 'Separa completamente tus activos personales de los empresariales, protegiéndote de demandas y deudas comerciales.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Optimización Fiscal',
      description: 'Accede a deducciones empresariales, reduce tu carga fiscal personal y optimiza tu estructura de ingresos.'
    },
    {
      icon: 'ri-building-line',
      title: 'Credibilidad Empresarial',
      description: 'Establece credibilidad institucional, facilita contratos comerciales y mejora tu imagen profesional.'
    },
    {
      icon: 'ri-bank-line',
      title: 'Acceso a Capital',
      description: 'Facilita la obtención de préstamos comerciales, líneas de crédito y atrae inversores institucionales.'
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Flexibilidad Operativa',
      description: 'Estructura flexible que se adapta al crecimiento de tu negocio y cambios en tus objetivos.'
    },
    {
      icon: 'ri-global-line',
      title: 'Expansión Internacional',
      description: 'Facilita operaciones internacionales y establece presencia en el mercado estadounidense.'
    }
  ];

  const process = [
    {
      step: '01',
      title: 'Consulta Inicial',
      description: 'Analizamos tu situación específica y determinamos la mejor estructura corporativa para tus objetivos.',
      duration: '30-60 minutos'
    },
    {
      step: '02',
      title: 'Documentación',
      description: 'Preparamos todos los documentos legales necesarios y los presentamos ante las autoridades correspondientes.',
      duration: '3-5 días'
    },
    {
      step: '03',
      title: 'Registro Oficial',
      description: 'Completamos el registro en el estado elegido y obtenemos todas las certificaciones necesarias.',
      duration: '7-14 días'
    },
    {
      step: '04',
      title: 'Setup Bancario',
      description: 'Te ayudamos a abrir cuentas bancarias empresariales y establecer el sistema financiero.',
      duration: '3-7 días'
    },
    {
      step: '05',
      title: 'Compliance Setup',
      description: 'Configuramos todos los sistemas de compliance y te entregamos el kit corporativo completo.',
      duration: '2-3 días'
    }
  ];

  return (
    <div className="min-h-screen bg-black pt-20">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-black via-gray-900 to-black py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-vip-gold/10 to-transparent"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6">
                  Creación de <span className="bg-gradient-to-r from-vip-gold to-vip-gold-light bg-clip-text text-transparent">Corporaciones</span>
                </h1>
                <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                  Protege tus activos, optimiza tus impuestos y establece la estructura legal perfecta para hacer crecer tu negocio con total seguridad.
                </p>

                <div className="grid grid-cols-2 gap-6 mb-8">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-vip-gold mb-2">500+</div>
                    <div className="text-gray-300">Corporaciones Formadas</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-vip-gold mb-2">100%</div>
                    <div className="text-gray-300">Tasa de Éxito</div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="https://web.cashflow.vip/widget/booking/dZafhFlPIO82YbvGywB0"
                    className="bg-gradient-to-r from-vip-gold to-vip-gold-light text-black px-8 py-4 rounded-full font-bold text-lg hover:shadow-lg hover:shadow-vip-gold/30 transition-all duration-300 whitespace-nowrap text-center"
                  >
                    Consulta Gratuita
                  </a>
                  <a
                    href="https://www.skool.com/cashflow"
                    className="border-2 border-vip-gold text-vip-gold px-8 py-4 rounded-full font-bold text-lg hover:bg-vip-gold hover:text-black transition-all duration-300 whitespace-nowrap text-center"
                  >
                    Ver Comunidad
                  </a>
                </div>
              </div>

              <div className="relative">
                <img
                  src="/images/878e867da1b36d45914141269b250482.webp"
                  alt="Creación de Corporaciones"
                  className="w-full h-auto rounded-2xl shadow-2xl"
                />
                <div className="absolute -bottom-6 -left-6 bg-gray-800 border border-gray-700 rounded-xl p-4">
                  <div className="flex items-center gap-3">
                    <i className="ri-shield-check-line text-2xl text-vip-gold"></i>
                    <div>
                      <div className="font-bold text-white">Protección Total</div>
                      <div className="text-sm text-gray-400">Activos Separados</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              ¿Por Qué Formar una <span className="text-vip-gold">Corporación?</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Una estructura corporativa adecuada es la base de cualquier negocio exitoso y próspero
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-xl hover:shadow-vip-gold/20 transition-all duration-300 border border-gray-700 group">
                <div className="w-16 h-16 bg-gradient-to-br from-vip-gold to-vip-gold-light rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${benefit.icon} text-2xl text-black`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{benefit.title}</h3>
                <p className="text-gray-300">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Nuestro <span className="text-vip-gold">Proceso</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Un proceso sistemático y probado para formar tu corporación de manera eficiente
            </p>
          </div>

          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-5 gap-8">
              {process.map((step, index) => (
                <div key={index} className="text-center group">
                  <div className="relative mb-6">
                    <div className="w-20 h-20 bg-gradient-to-br from-vip-gold to-vip-gold-light rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                      <span className="text-2xl font-bold text-black">{step.step}</span>
                    </div>
                    {index < process.length - 1 && (
                      <div className="hidden md:block absolute top-10 left-full w-full h-0.5 bg-gray-700"></div>
                    )}
                  </div>
                  <h3 className="text-lg font-bold text-white mb-3">{step.title}</h3>
                  <p className="text-gray-300 text-sm mb-2">{step.description}</p>
                  <div className="text-xs text-vip-gold font-medium">{step.duration}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>



      {/* FAQ Section */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Preguntas <span className="text-vip-gold">Frecuentes</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Resolvemos las dudas más comunes sobre la formación de corporaciones
            </p>
          </div>

          <div className="max-w-4xl mx-auto space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-gray-800 rounded-xl border border-gray-700 overflow-hidden">
                <button
                  onClick={() => setSelectedPlan(selectedPlan === `faq-${index}` ? null : `faq-${index}`)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-750 transition-colors"
                >
                  <h3 className="font-bold text-white">{faq.question}</h3>
                  <i className={`ri-arrow-${selectedPlan === `faq-${index}` ? 'up' : 'down'}-s-line text-vip-gold text-xl`}></i>
                </button>
                {selectedPlan === `faq-${index}` && (
                  <div className="px-6 pb-4">
                    <p className="text-gray-300">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-black via-gray-900 to-black">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6">
            ¿Listo para <span className="bg-gradient-to-r from-vip-gold to-vip-gold-light bg-clip-text text-transparent">Proteger</span> tu Negocio?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            No esperes más. Forma tu corporación hoy y comienza a disfrutar de todos los beneficios legales y fiscales.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-12">
            <a
              href="https://web.cashflow.vip/widget/booking/dZafhFlPIO82YbvGywB0"
              className="bg-gradient-to-r from-vip-gold to-vip-gold-light text-black px-10 py-5 rounded-full font-bold text-xl hover:shadow-lg hover:shadow-vip-gold/30 transition-all duration-300 whitespace-nowrap"
            >
              Consulta Gratuita Ahora
            </a>
            <a
              href="https://www.skool.com/cashflow"
              className="border-2 border-vip-gold text-vip-gold px-10 py-5 rounded-full font-bold text-xl hover:bg-vip-gold hover:text-black transition-all duration-300 whitespace-nowrap"
            >
              Unirse a la Comunidad
            </a>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {[
              { icon: 'ri-shield-check-line', text: 'Protección Garantizada' },
              { icon: 'ri-time-line', text: 'Formación en 2-4 Semanas' },
              { icon: 'ri-customer-service-line', text: 'Soporte Completo' }
            ].map((item, index) => (
              <div key={index} className="flex items-center justify-center gap-3 text-white">
                <i className={`${item.icon} text-2xl text-vip-gold`}></i>
                <span className="font-medium">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default CreacionCorporacionesPage;
